module.exports = __webpack_public_path__ + "img/20.b9644f82.webp";